import { instance } from "../index";

// Server-authoritative subscription state.
// Returns: { subscription, isPremium, promoSubscription }
export const getSubscription = async () => {
  const { data } = await instance.get("/api/user/subscription");
  return data;
};
